import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const PrevzitHodnoty = {
	name: NAME,
	apiProvider,
	router,
};
